import {apiConfig} from '@stencil/hotels-config';

export default function prepareTravellerImagesUrl(hotelId, offset, limit) {
  let url = `${apiConfig.__UGC__}/api/Images/getApprovedImages/?vid=${hotelId}&offset=${offset}&limit=${limit}`;
  return url;
}
